import endPoints from 'pre_chat/api/endPoints';
import { API } from 'pre_chat/helpers/axios';

const generateRedirectUrl = async ({
  websiteToken,
  channelType,
  visitorId,
  name,
  phoneNumber,
  emailAddress,
  customAttributes,
  opportunityCustomAttributes,
  vsid,
  vvid,
  vsrc,
}) => {
  const urlData = endPoints.generateRedirectUrl({
    websiteToken,
    channelType,
    visitorId,
    name,
    phoneNumber,
    emailAddress,
    customAttributes,
    opportunityCustomAttributes,
    vsid,
    vvid,
    vsrc,
  });
  const result = await API.post(urlData.url, { ...urlData.data });
  return result;
};

export { generateRedirectUrl };
